<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Novo Membro Externo'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-center>
                  <v-flex sm10 xs12>
                    <v-text-field
                      label='Nome'
                      v-model="pessoa.nome"
                      required
                      :rules="assuntoSummaryRules255"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-center>
                  <v-flex sm10 xs12>
                    <v-checkbox v-model="temNomeSocial" label="Possui nome social?"></v-checkbox>
                  </v-flex>
                  <v-flex sm10 xs12>
                    <v-text-field v-if="temNomeSocial"
                      label='Nome Social'
                      v-model="pessoa.nomeSocial"
                      required
                      :rules="assuntoSummaryRules255"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-center>
                  <v-flex sm10 xs12>
                    <v-text-field
                      label='CPF'
                      v-model="pessoa.cpf"
                      mask="###.###.###-##"
                      return-masked-value
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="criarPessoa(false)" :disabled="!formularioValido">Cadastrar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      temNomeSocial: false,
      pessoa: {
        nome: '',
        nomeSocial: '',
        cpf: ''
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules255: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ParceriasProjeto', params: {idProjeto: this.idProjeto}})
      },
      criarPessoa: function (avancar) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' })

        if (!this.temNomeSocial) {
          this.pessoa.nomeSocial = this.pessoa.nome
        }

        projetos.postPessoa(this.pessoa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          let link = response.body.link
          let idPessoa = link.split('/')[5]
          if (confirm('Deseja adicionar essa pessoa como integrante do projeto?')) {
            this.adicionarIntegrante(idPessoa)
          } else {
            this.$router.go(-1)
          }
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Criando novo membro externo.' })
        })
      },
      adicionarIntegrante (idPessoa) {
        console.log('Entrou aqui')
        // let hoje = new Date()
        // let dd = hoje.getDate()
        // let mm = hoje.getMonth() + 1
        // let yyyy = hoje.getFullYear()
        let data = this.projeto.dataInicio
        let integrante = {
          idPessoa: idPessoa,
          funcao: {item: 18, descricao: 'Integrante'},
          titulacao: {item: 99, descricao: 'Escolaridade/Titulação Indefinida'},
          cargaHoraria: 0,
          dataInicial: data,
          situacao: 'A'
        }
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' })
        projetos.postIntegrante(this.$props.idProjeto, integrante)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: 'Integrante adicionado com sucesso!'})
          let listaLink = response.body.link.split('/')
          let idIntegranteAux = listaLink[listaLink.length - 1]
          this.$router.push({name: 'EditarIntegrante', params: {idProjeto: this.idProjeto, idParticipante: idIntegranteAux}})
        })
        .catch(error => {
          console.log('Erro ao mandar a requisição' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Adicionando integrante...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
        this.dataInicioFormatada = this.dates.format(this.projeto.dataInicio)
        this.dataConclusaoFormatada = this.dates.format(this.projeto.dataConclusao)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// nova-pessoa.vue?1d624fc8